import { createLabeledMessages } from '../../../messageUtils';
const pdf = {
    load: 'Načítání dokumentu',
    pageLoad: 'Načítání {{number}} stránky',
    noData: 'PDF dokument není vybrán',
    pageNoData: 'Není vybrána stránka',
    error: 'Načtení dokumentu se nezdařilo',
    pageError: 'Načtení {{number}} stránky se nezdařilo'
};
export default Object.assign({}, pdf, createLabeledMessages(pdf));
